<div tabindex="0" class="placeholder-container" (click)="onFieldClick($event)" (keyup.tab)="onTab($event)">
  <ng-container *ngIf="propertyValue || attachmentValues.length; else placeholder">
    <ng-container [ngSwitch]="property.kind">
      <p *ngSwitchCase="ListEntryTypes.Text" class="text-cell">{{ propertyValue }}</p>
      <p *ngSwitchCase="ListEntryTypes.Number" class="number-cell">{{ propertyValue }}</p>
      <p *ngSwitchCase="ListEntryTypes.Date" class="date-cell">{{ propertyValue }}</p>
      <p *ngSwitchCase="ListEntryTypes.DateExpiry" class="date-expiry-cell" [ngClass]="dateExpiryClass">
        {{ propertyValue }}
      </p>
      <div class="attachments-container" *ngSwitchCase="ListEntryTypes.Attachment">
        <div *ngFor="let attachment of attachmentValues" class="attachment-cell">
          <em class="cc-icon cc-icon-file-pdf"></em>
          <a [href]="attachment.fullUrl" target="_blank"> {{ attachment.filename }} </a>
        </div>
      </div>
    </ng-container>
  </ng-container>

  <ng-template #placeholder>
    <p class="placeholder">{{ placeHolderText }}</p>
  </ng-template>
</div>
